// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"6ec0dfa1","453":"a7588273"}[chunkId] + ".chunk.js";
};